/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable, signal } from "@angular/core";
import { map, Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { apiUrls } from "../core/constants/apiUrls.const";
import { commonResponse } from "../models/common.model";

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  private http = inject(HttpClient);
  public showDot = signal<boolean>(false);
  public refreshTick = signal(0);

  getUsersList(query: string): Observable<any> {
    return this.http
      .get<{ data: any }>(
        `${environment.base_url}${apiUrls.usersList}?${query}`
      )
      .pipe(map((res) => res.data));
  }

  addNotification(payload: any): Observable<any> {
    return this.http
      .post<{
        data: any;
      }>(`${environment.base_url}${apiUrls.addNotification}`, payload)
      .pipe(map((res) => res.data));
  }

  getNotificationListing(query: string): Observable<any> {
    return this.http
      .get<{ data: any }>(
        `${environment.base_url}${apiUrls.notificationList}?${query}`
      )
      .pipe(map((res) => res.data));
  }

  
    deleteNotification(id: string): Observable<commonResponse> {
      return this.http
        .delete<commonResponse>(
          `${environment.base_url}${apiUrls.notificationList}/${id}`
        )
        .pipe(map(res => res));
    }
}
